<template>
  <div style="position: relative;width: 100vw;height: 100vh;"
       :style="{background: `url('${shootInfo.finalPicture}') center / cover no-repeat`}">
    <TopShareBar v-if="share"/>
    <div v-if="canDownload" @click="downloadImage(shootInfo.finalPicture)" class="mid-center iconfontFamily" style="position: absolute;bottom: 238px;right: 21px;background: rgba(0, 0, 0, 0.42);width: 38px;height: 38px;border-radius: 4px;color: white;font-size: 20px;">&#xe827;</div>
    <div style="position: absolute;bottom: 40px;left: 16px;right: 16px;width: calc(100vw - 32px);height: 180px;background: rgba(3, 5, 15, 0.6);border-radius: 8px;backdrop-filter: blur(20px);border: 1px solid rgba(255, 255, 255, 0.4)">
      <img src="@/assets/SatelliteActivityShoot/quotation.png" style="position: absolute;left: 10px;top: 50px;color: rgba(226, 232, 241, 1);width: 52px;"/>
      <div style="position: absolute;left: -1px;top: 79px;width: 2px;height: 16px;background-color: white"></div>
      <div style="position: absolute;right: -1px;top: 79px;width: 2px;height: 16px;background-color: white"></div>
      <div style="position: relative;padding: 25px 22px 12px 24px">
        <div style="display: flex;">
          <img :src="shootInfo.userPicture" style="width: 26px;height: 26px;border-radius: 50%">
          <div style="margin-left: 5px;font-family: HarmonyOSSansSCRegular,serif;color: white">
            <div style="font-size: 14px;">{{ shootInfo.userName }}</div>
            <div style="font-size: 10px;">{{ shootInfo.createtime }}</div>
          </div>
        </div>
        <div class="introduction-text">
          {{ shootInfo.userText }}
        </div>
      </div>
      <div style="display: flex;align-items: center;bottom: 12px;left: 22px;position: absolute;">
        <div style="color: white;font-size: 16px;" class="iconfontFamily">&#xe7bb;</div>
        <div style="color: white;margin-left: 5px;font-size: 14px;font-family:HarmonyOSSansSCRegular"
             class="iconfontFamily">{{ shootInfo.poi }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopShareBar from "@/components/TopShareBar.vue";

export default {
  name: 'SatelliteShootDetail',
  components: {TopShareBar},
  data() {
    return {
      share: false,
      infoId: '',
      shootInfo: '',
      canDownload: false,
    }
  },
  methods: {
    getShootDetail(id) {
      this.$http.get('/earthApi/satellite-shoot-info/getLatestSatelliteShootInfo?shootId=' + id).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.shootInfo = resp.data
          if (this.share) {
            document.title = `${this.shootInfo.userName}的卫星帮拍`
          }
          if (!this.share) {
            if (window['flutter_getSatelliteShootUsername']) {
              window['flutter_getSatelliteShootUsername'].postMessage(this.shootInfo['userName'])
            }
          }
        }
      })
    },
    enableDownload() {
      this.canDownload = true
    },
    downloadImage(url) {
      if (window['flutter_downloadSatelliteShootImage']) {
        window['flutter_downloadSatelliteShootImage'].postMessage(url)
      }
    },
  },
  mounted() {
    window.satelliteShootDetail = this
    this.share = this.$route.query.share === '1'
    this.infoId = this.$route.query.infoId
    this.getShootDetail(this.$route.query.infoId)
  }
}
</script>

<style scoped>
.mid-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.introduction-text {
  color: white;
  font-size: 16px;
  line-height: 24px;
  font-family: HarmonyOSSansSCRegular, sans-serif; /* 先用系统字体 */
  display: block;
  width: 100%;
  margin-top: 5px;
  /* 多行省略 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>